import * as React from 'react';
import {QuoteListingSearchFilter} from './QuoteFilter/QuoteListingSearchFilter';
import {SubmittedQuoteList} from './SubmittedQuoteList';
import {SubmittedQuoteFilterList} from './SubmittedQuoteFilterList';
import { useQuoteFilterSelectionStore } from 'src/hooks/component/quote-filter-selection';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import { useEffect } from 'react';
import ReusableDiv from 'src/support/ReusableDiv';
import SystemAlerts from 'src/component/SystemAlerts';

export function QuoteListing() {
    const [{filter_list}, {}, {}] = useQuoteFilterSelectionStore();
    const [{ }, { }, { destroy_cart_quote_active_session }] = useQuoteDetailStore();

    useEffect(() => {
        destroy_cart_quote_active_session();
    }, []);

    return (
        <>
            <div id="main" className="">
                {ReusableDiv.QuoteHeader()}
                <div className=''>
                    <SystemAlerts className="mt-2" />
                </div>
                <div id="submitted-pcnquote-page" className="pcn-page container quote-tabs">
                        <QuoteListingSearchFilter/>
                        <div className='quote-tabs-content'>
                            {filter_list?.length > 0 ? 
                                <SubmittedQuoteFilterList/> :
                                <SubmittedQuoteList/>
                            }
                    </div>
                </div>

            </div>
        </>
    );

}
